import SkipLinks from '@italia/components/ItaliaTheme/SkipLinks/SkipLinks';

export default SkipLinks;
